import { IFamilyHealthHistory } from "../../resources-vue/vue-interfaces/i-health";
import { PatientRelations } from "./patient-relations";

export class FamilyHealthHistoryModel implements IFamilyHealthHistory {
    public Condition: string = "";
    public ConditionCode: string = "";
    public PatientRelations: PatientRelations[] = [];

    public constructor(data?: IFamilyHealthHistory) {
        if (!!data) {
            Object.assign(this, data);
        }
    }
}
